module.exports = __webpack_public_path__ + "static/frame-mock-ed257d2edb7dcc64871bd673d61a737f.png";